import { InputMail, InputMailProps } from "./Mail"
import { InputPassword, InputPasswordProps } from "./Password"
import { InputPhone, InputPhoneProps } from "./Phone"
import { InputCity, InputCityProps } from "./City"
import { InputText, InputTextProps } from "./Text"
import { InputNumber, InputNumberProps } from "./Number"
import { InputTextarea, InputTextareaProps } from "./Textarea"
import { InputCheckbox as Checkbox, InputCheckboxProps } from "./Checkbox"
import { InputRadio as Radio, RadioProps } from "./Radio"
import { Select, SelectProps } from "./Select"
import {
	InputCodeVerification,
	InputCodeVerificationProps,
} from "./CodeVerification/InputCodeVerification"
import { InputFile, InputFileProps } from "./File"

type FormElementProps = {
	type: string
}

export const FormElement = (
	props: FormElementProps &
		(
			| InputTextProps
			| InputNumberProps
			| InputCityProps
			| InputCheckboxProps
			| InputMailProps
			| InputPasswordProps
			| InputCheckboxProps
			| RadioProps
			| SelectProps
			| InputCodeVerificationProps
			| InputFileProps
			| InputTextareaProps
		)
) => {
	const renderSwitch = (type: string) => {
		switch (type) {
			case "text":
				return <InputText {...(props as InputTextProps)} />

			case "number":
				return <InputNumber {...(props as InputNumberProps)} />

			case "email":
				return <InputMail {...(props as InputMailProps)} />

			case "city":
				return <InputCity {...(props as InputCityProps)} />

			case "password":
				return <InputPassword {...(props as InputPasswordProps)} />

			case "phone":
				return <InputPhone {...(props as InputPhoneProps)} />

			case "textarea":
				return <InputTextarea {...(props as InputTextareaProps)} />

			case "checkbox":
				return <Checkbox {...(props as InputCheckboxProps)} />

			case "radio":
				return <Radio {...(props as RadioProps)} />

			case "select":
				return <Select {...(props as SelectProps)} />

			case "code":
				return <InputCodeVerification {...(props as InputCodeVerificationProps)} />

			case "file":
				return <InputFile {...(props as InputFileProps)} />

			default:
				return <InputText {...(props as InputTextProps)} />
		}
	}
	return <>{renderSwitch(props.type)}</>
}
